import { render, staticRenderFns } from "./h-transaction-page.vue?vue&type=template&id=326a8974&"
import script from "./h-transaction-page.vue?vue&type=script&lang=js&"
export * from "./h-transaction-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports